export const KYC_VERIFICATION_CONSTANTS = {
  ANIMATION: {
    RENDER_DELAY: 500, // Reduced from 2000ms since we don't need to wait for dashboard
    ANIMATION_DELAY: 100,
    SLIDE_TIMEOUT: 600,
    FADE_TIMEOUT: 800,
  },
  UI: {
    ICON_SIZE: 24,
    MOBILE_DESCRIPTION_WIDTH: '50%',
  },
  ROUTES: {
    VERIFICATION_PATH: '/profile/verification',
  },
  TRANSLATION_KEYS: {
    TITLE: 'kyc_verification_section.title',
    DESCRIPTION: 'kyc_verification_section.description',
    VERIFY_BUTTON: 'kyc_verification_section.action.verify_now',
  },
} as const;
